import { useAuth } from "@utils/hooks/useAuth";
import { useCallback } from "react";
import styles from "./ClientTableGrid.module.scss";
import { UserRole } from "@services/http/responses/AccountResponse";


export function useClientsTableUtils() {

  const auth = useAuth();

  const getRoleClassName = useCallback((mock: UserRole) => {
    switch (mock) {
      //switch (getRole()) {
      case UserRole.God:
        return styles.god;
      case UserRole.SuperAdmin:
        return styles.superAdmin;
      case UserRole.Admin:
        return styles.admin;
      case UserRole.Tech:
        return styles.tech;

      default:
        return "";
    }
  }, [auth.role]);

  return {
    getRoleClassName,
  }
}

export enum SortUsersE {
  ID,
  EMAIL,
  NAME,
  FA,
  ONLINE,
  LOW,
  OFFLINE,
  TOTAL,
  ROLE,
}

export interface IClientsTableHeadItem {
  id: string;
  labelId: string;
  type?: string;
  sort?: SortUsersE;
  //roles: UserRole[];
}

export const CLIENT_ROW_ACCESS = {
  email: [UserRole.God, UserRole.SuperAdmin, UserRole.Admin, UserRole.Tech],
  role: [UserRole.God, UserRole.SuperAdmin, UserRole.Admin, UserRole.Tech],
  code: [UserRole.God, UserRole.SuperAdmin, UserRole.Admin],
  customer: [UserRole.God, UserRole.SuperAdmin, UserRole.Admin],
  comment: [UserRole.God, UserRole.SuperAdmin, UserRole.Admin, UserRole.Tech],
  link: [UserRole.God, UserRole.SuperAdmin],
  "2fa": [UserRole.God, UserRole.SuperAdmin],
  online: [UserRole.God, UserRole.SuperAdmin, UserRole.Admin],
  low: [UserRole.God, UserRole.SuperAdmin, UserRole.Admin],
  offline: [UserRole.God, UserRole.SuperAdmin, UserRole.Admin],
  total: [UserRole.God, UserRole.SuperAdmin, UserRole.Admin],
  color: [UserRole.God, UserRole.SuperAdmin, UserRole.Admin, UserRole.Tech],
}

export const CLIENT_TABLE_COLUMNS: IClientsTableHeadItem[] = [
  // {
  //   label: formatMessage({ id: "clients.table.id" }),
  //   sort: SortUsersE.ID,
  // },
  {
    id: "email",
    labelId: "clients.table.email",
    sort: SortUsersE.EMAIL,
    //roles: [UserRole.God, UserRole.SuperAdmin],
  },
  {
    id: "role",
    labelId: "clients.table.role",
    sort: SortUsersE.ROLE,
    //roles: [UserRole.God, UserRole.SuperAdmin],
  },
  {
    id: "code",
    labelId: "clients.table.code",
    //roles: [UserRole.God, UserRole.SuperAdmin, UserRole.Admin],
  },
  {
    id: "customer",
    labelId: "clients.table.customer",
    sort: SortUsersE.NAME,
    //roles: [UserRole.God, UserRole.SuperAdmin, UserRole.Admin],
  },
  {
    id: "comment",
    labelId: "clients.table.comment",
    //roles: [UserRole.God, UserRole.SuperAdmin, UserRole.Admin],
  },
  {
    id: "link",
    labelId: "clients.table.link",
    //roles: [UserRole.God, UserRole.SuperAdmin],
  },
  {
    id: "2fa",
    labelId: "clients.table.2fa",
    sort: SortUsersE.FA,
    //roles: [UserRole.God, UserRole.SuperAdmin],
  },
  {
    id: "online",
    labelId: "clients.table.online",
    sort: SortUsersE.ONLINE,
    type: "count",
    //roles: [UserRole.God, UserRole.SuperAdmin, UserRole.Admin],
  },
  {
    id: "low",
    labelId: "clients.table.low",
    sort: SortUsersE.LOW,
    type: "count",
    //roles: [UserRole.God, UserRole.SuperAdmin, UserRole.Admin],
  },
  {
    id: "offline",
    labelId: "clients.table.offline",
    sort: SortUsersE.OFFLINE,
    type: "count",
    //roles: [UserRole.God, UserRole.SuperAdmin, UserRole.Admin],
  },
  {
    id: "total",
    labelId: "clients.table.summ",
    sort: SortUsersE.TOTAL,
    type: "count",
    //roles: [UserRole.God, UserRole.SuperAdmin, UserRole.Admin],
  },
  {
    id: "color",
    labelId: "clients.table.color",
    //roles: [UserRole.God, UserRole.SuperAdmin, UserRole.Admin],
  },
];